import { Pipe, PipeTransform } from "@angular/core";
import { throwError } from "rxjs";

@Pipe({
    name: 'deEnumDisplay',
    standalone: false
})
export class EnumDisplayPipe implements PipeTransform {
    transform(value: any, ...args: any[]) {
        if (args == null && args.length <= 0) {
            console.log('Please put the enum type to EnumDisplayPipe');
        }
        else {
            let enumType = args[0]
            if (enumType != null) {
                let result = enumType[value];
                // insert a space before all caps
                result = result.replace(/([A-Z])/g, ' $1')
                return result;
            }
        }

        return '';
    }

}